import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const resetPassword = (passwordData) => async (dispatch) => {
  dispatch({ type: RESET_PASSWORD_REQUEST });
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  try {
    const response = await axios.put(
      `${BASE_URL}/v1/api/ulbLevelAdmins/${userId}/resetPasswordOwn`,
      passwordData,
      { headers: { authorization: token } },
    );

    if (response.data.meta.status) {
      dispatch({ type: RESET_PASSWORD_SUCCESS });
      toast.success(
        response.data.meta.message || "Password reset successfully!",
      );
      return response.data;
    } else {
      dispatch({ type: RESET_PASSWORD_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: RESET_PASSWORD_FAILURE });
    let errorMessage = "Failed to reset password";
    if (error.response?.data?.meta?.message) {
      errorMessage = error.response.data.meta.message;
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    toast.error(errorMessage);
    throw error;
  }
};
